import { useState, useEffect } from "react";

export default function useContextMenu(editorRef, formatText) {
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    top: 0,
    left: 0,
  });

  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;

    const handleContextMenu = (e) => {
      const selection = window.getSelection();
      if (!selection.rangeCount || selection.isCollapsed) return;

      e.preventDefault();
      setContextMenu({
        visible: true,
        top: e.clientY + window.scrollY,
        left: e.clientX + window.scrollX,
      });
    };

    const handleClick = () => setContextMenu((p) => ({ ...p, visible: false }));

    editor.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("click", handleClick);

    return () => {
      editor.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("click", handleClick);
    };
  }, [editorRef, formatText]);

  return { contextMenu };
}